import {Component} from 'react';
import resultimg from './../../img/resultat-positif.png';
import phone from './../../img/08-simulateur.png';
import {FormError} from './form-errors.js';

class Espacemembre extends Component {
	state = {
		subscribe : true,
		agreeConfidentiality : false,
		email: "",
		password:"",
		connectErrors : [],
		subscribeError : [],
		support : "", //email pour le support
		supportError : false,
		supportSuccess:false,
		recovery:false,
		recoverysent:false,
		hs:false,
	} ;

	switchConfidentialityAgreement = (e)=>{
		const value = JSON.parse(e.target.checked);
		this.setState({agreeConfidentiality : value});
	}

	showConnect = () => {
		this.setState({subscribe : false});
		this.props.removefeedback()
	}

	hideConnect = () => {
		this.setState({subscribe : true});
	}
	setMail = (e) => {
		const value = e.target.value;
		this.setState({email : value});
	}
	setPassword= (e) => {
		const value = e.target.value;
		this.setState({password:value});
	}

	setSupport = (e) => {

		const value = e.target.value;
		this.setState({support:value});
	}

	connect = () => {
		let connectErrors = [];
		if (this.state.email === "" || this.state.email === null) {
			connectErrors.push( 'Veuillez saisir un email valide.')
		}
		if (this.state.password === "" || this.state.password === null){
			connectErrors.push( 'Veuillez saisir un mot de passe valide.')
		}

		this.setState({connectErrors:connectErrors});

		if (connectErrors.length === 0){
			this.props.connect(this.state.email , this.state.password);
		}
	}


	recoveryPassword = () => {
		if(this.validateEmail(this.state.email)){
			this.props.recoveryPassword(this.state.email);
			this.setState({recoverysent:true})
		}
	}



	subscribe = () =>{

		let subscribeError =[];
		if (this.state.email === null || this.state.email === "") {
			subscribeError.push("Veuillez saisir un email valide.");
		}
		
		
		this.setState({subscribeError:subscribeError});
		if (subscribeError.length === 0 && this.state.agreeConfidentiality)
			this.props.subscribe(this.state.email);
	}

	support = () => {
		let email = this.state.support;
		//validate email 
		if(this.validateEmail(email)){
			this.setState({supportError:false}); //on remet a la normale
			this.props.support(email);
			this.setState({supportSuccess:true});
		}else {
			this.setState({supportError : "L'adresse email n'est pas valide!"});
			this.setState({supportSuccess:false});
		}		
	}

	showRecovery = () => {
		this.setState({recovery:true});
	}

	validateEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    	return emailRegex.test(email);
	}

	toggleSupport = () => {
		this.setState({hs:!this.state.hs});
	}

	render(){
        let email = window.email;
		let situationIdRemote = window.situationId;
		let isMember = email && situationIdRemote;
        if(isMember ){
            return (
                    <div className="espacemembre">
                       <div className="loginform"></div>
                       <div className="desktopimage" >
                            <img src="https://www.aide-sociale.fr/wp-content/uploads/2026/11/cartouche-3493-telephone-v2.png" className="illustration" />
                            <a href="tel:3493">
                              <img src="https://www.aide-sociale.fr/wp-content/uploads/2026/11/cartouche-3493-telephone-v2.png" className="phone-image"/>
                            </a>
                       </div>
                    </div>);
        }else{
		    return (
			<div className="espacemembre" >
				<div className="loginform" >
					<h1>Félicitations !</h1>
					<p>Découvrez les résultats de votre simulation ci-dessous </p>
					<hr/>
					<h5>Vous pouvez conserver vos résultats et modifier votre simulation au sein de votre espace membre.<br/>
					Pour cela, créez-le en indiquant votre adresse e-mail :
					</h5>

					<div className={"subscribe " +(this.state.subscribe ? 'show' : 'hide')} >
						<input
						  type="email"
						  className="emailsubscribe"
						  placeholder="Adresse email"
						  onChange={this.setMail}
						 />
						{( typeof this.props.feedback !== 'undefined' &&this.props.feedback.load) ?
							<div className="loader feedbackespacemembre"></div>
						:""}

						<div className="clear" ></div>
						 <FormError errors={this.state.subscribeError}/>

						

						{( typeof this.props.feedback !== 'undefined' && this.props.feedback.load !== true) ?
						<>

							<div className="clear"></div>

							<div className= {"feedback " + ( this.props.feedback.error ? 'error' : 'success')}
							>
								{this.props.feedback.message}
							</div>
							<div className={"recovery success " +(this.state.recoverysent ? 'show' : 'hide')} >
								Un email a été envoyé pour réinitialiser votre mot de passe!
							</div>
							<button className="switchconnect" onClick={this.recoveryPassword}>Réinitialiser mon mot de passe </button>
							<div className="clear"></div>
						</> : ''
						}
						<div className="clear"></div>
						<div className="custom-radiobox custom-switch  radiobox-checked">
						  <label className="custom-control-label radio-container" style={{width:'auto',background:'transparent',marginLeft:'-13px',paddingLeft:'30px'}}>
						  	<input id="confidentiality" type="checkbox"  name="confirmation" onClick={this.switchConfidentialityAgreement}/>
						    <span className="checkmark"></span>
						    J'ai lu et accepté la
						    <a style={{color:'#007bff'}} href="https://www.aide-sociale.fr/politique-confidentialite/" target="_blank">
						      <span className="link-bold"> politique de confidentialité </span>
						    </a>
						  </label>
						</div>
						<div className="clear"></div>
						<button className={"inscription " + (this.state.agreeConfidentiality ? "" : " disabled") } onClick={this.subscribe} >Envoyer </button>
						<div className="clear"></div>
						<p><strong>Vous avez déjà un compte ?</strong></p>
						<button className="switchconnect" onClick={this.showConnect}>Se connecter </button>
						<div className="clear"></div>
					</div>

					<div className={"subscribe " +(this.state.subscribe ? 'hide' : 'show')} >
					{(this.state.recovery === false) &&
					<>
						<p><strong>Se connecter a l'espace membre</strong></p>
						<input 
						  type="email"
						  className="emailsubscribe"
						  placeholder="Adresse email"
						  defaultValue={this.state.email}
						  onChange={this.setMail}
						/>
						<input
						  type="password"
						  className="emailsubscribe"
						  placeholder="Mot de passe"
						  defaultValue={this.state.password}
						  onChange={this.setPassword}
						/>
						<FormError errors={this.state.connectErrors}/>
						<button className="inscription" onClick={this.connect}>Envoyer </button>
						<button className="switchconnect" onClick={this.showRecovery} >Mot de passe oublié</button>
						<div className="clear"></div>
					</>
					}
					{(this.state.recovery === true) &&
					<>
						<p><strong>Réinitialiser le mot de passe</strong></p>
						<p>Veuillez indiquer votre adresse email</p>
						<input 
						  type="email"
						  className="emailsubscribe"
						  placeholder="Adresse email"
						  defaultValue={this.state.email}
						  onChange={this.setMail}
						/>
						<button className="inscription" onClick={this.recoveryPassword}>Envoyer </button>
						<div className="clear"></div>
						<div className={"recovery success " +(this.state.recoverysent ? 'show' : 'hide')} >
							Un email a été envoyé pour réinitialiser votre mot de passe!
						</div>
					</>
					}

						<br/>

						{( typeof this.props.feedback !== 'undefined' ) ?
						<>
							<div className="clear"></div>

							<div className= {"feedback " + ( this.props.feedback.error ? 'error' : 'success')}
							>
								{this.props.feedback.message}
							</div>

							<div className="clear"></div>
						</> : ''
						}
						<p><strong>Vous n'avez pas de compte ? </strong></p>
						
						
						<button className="switchconnect" onClick={this.hideConnect}>S'inscrire</button>
						<div className="clear"></div>
					</div>

				</div>
				<div className="desktopimage" >
					<img src="https://aide-sociale.fr/build/static/media/resultat-positif.9b86c10372b3037fd263.png" className="illustration" />
					<a href="tel:3493">
		              <img src="https://www.aide-sociale.fr/wp-content/uploads/2026/11/cartouche-3493-telephone-v2.png" className="phone-image"/>
		            </a>
		            <div className="supportbutton" onClick={this.toggleSupport} ><span>+</span></div>
		            {(this.state.hs === true) && 
		        	<>
		            	<small>Envoyer mes résultats par email</small>
			            <div className="support">
						<input type="email" id="email" className="emailsubscribe" onChange={this.setSupport} /><button className="support" onClick={this.support}>Envoyer</button>
						</div>
					</>
					}
					{(this.state.supportError !== false) &&
		            	<small className="error">* {this.state.supportError}</small>
		        	}
					{(this.state.supportSuccess === true) &&
		            	<small className="success">Email envoyé!</small>
		        	}
				</div>

			</div>
		)
        }
	}

}

export default Espacemembre;
